import { render, staticRenderFns } from "./CampaignListItem.vue?vue&type=template&id=241069b0"
import script from "./CampaignListItem.vue?vue&type=script&lang=js"
export * from "./CampaignListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports